module.exports = __webpack_public_path__ + "static/media/King David Inc Receivership-Order-Applicant-First-Source-20DEC23.369c93cc.pdf";